// extracted by mini-css-extract-plugin
export default {"pag":"Pag404_pag__6pgsy","error":"Pag404_error__ACVFs"};